import { Component, Input } from '@angular/core';
import { NgFor, NgIf } from '@angular/common';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { LenientDatePipe } from 'src/app/shared/pipes/lenient-date.pipe';
import { PhonePipe } from 'src/app/shared/pipes/phone.pipe';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Store } from '@ngrx/store';
import { DelegationAddEditDialogComponent } from 'src/app/delegations/delegation-add-edit-dialog/delegation-add-edit-dialog.component';
import { DelegationSetInactiveDialogComponent } from 'src/app/delegations/delegation-set-inactive-dialog/delegation-set-inactive-dialog.component';
import { Delegation, DelegationAddEdit } from 'src/app/delegations/models/delegation';
import { DelegationUser } from 'src/app/delegations/models/delegation-user';
import { updateDelegation, setDelegationToInactive } from 'src/app/delegations/store/actions/delegations.actions';
import { DelegationsState } from 'src/app/delegations/store/delegations.state';

@UntilDestroy()
@Component({
    selector: 'nova-delegation-card',
    standalone: true,
    imports: [
        MatDialogModule,
        MatIconModule,
        MatDividerModule,
        MatButtonModule,
        LenientDatePipe,
        PhonePipe,
        NgIf,
        NgFor
    ],
    templateUrl: './delegation-card.component.html',
    styleUrls: ['./delegation-card.component.scss']
})
export class DelegationCardComponent {
    @Input()
    delegation: Delegation;

    @Input()
    aspNetUserId: string;

    @Input()
    condensedView = false;

    isContactInfoHidden = true;

    constructor(
        private readonly _store: Store<DelegationsState>,
        private readonly _dialog: MatDialog
    ) {}

    get isDelegationOwner(): boolean {
        return this.delegation.ownerAspNetUserId === this.aspNetUserId;
    }

    get delegationUser(): DelegationUser {
        return this.isDelegationOwner ? this.delegation.delegatedUser : this.delegation.delegatingUser;
    }

    cancelDelegation() {
        const dialog = this._dialog.open(DelegationSetInactiveDialogComponent, {
            panelClass: ['nova__dialog', 'nova__dialog--md'],
            disableClose: false,
            data: {
                isCurrent: this.delegation.isCurrent
            }
        });

        dialog
            .afterClosed()
            .pipe(untilDestroyed(this))
            .subscribe((setInactive: boolean) => {
                if (setInactive) {
                    this._store.dispatch(setDelegationToInactive({ delegation: this.delegation }));
                }
            });
    }

    editCoverage() {
        const dialog = this._dialog.open(DelegationAddEditDialogComponent, {
            panelClass: ['nova__dialog', 'nova__dialog--md'],
            disableClose: false,
            data: {
                delegation: this.delegation,
                ownerAspNetUserId: this.aspNetUserId
            }
        });

        dialog
            .afterClosed()
            .pipe(untilDestroyed(this))
            .subscribe((delegation: DelegationAddEdit) => {
                if (delegation) {
                    this._store.dispatch(updateDelegation({ delegation }));
                }
            });
    }

    toggleContactInfo() {
        this.isContactInfoHidden = !this.isContactInfoHidden;
    }
}
